module.exports = __webpack_public_path__ + "img/MES8Indice1.aaf6a878.png";